import styled from "@emotion/styled";
import { fontAngkor } from "@product/scmp-sdk";

import Divider from "./divider.svg?url";
import Pangolin from "./pangolin.svg?url";

export const StyledArticleMoreStories = styled.div`
  position: relative;

  padding-block: 39px 39px;
  &::before {
    position: absolute;
    inset-block-start: 0;
    inset-inline-start: 50%;
    content: "";

    inline-size: 100%;
    block-size: 15px;

    background: url(${Divider});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    transform: translateX(-50%);

    overflow: hidden;

    ${props => props.theme.breakpoints.up("tablet")} {
      max-inline-size: 743px;
    }
    ${props => props.theme.breakpoints.up("mediumDesktop")} {
      max-inline-size: none;
    }
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block: 80px 30px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    padding-block: 80px 40px;
  }
`;

export const Title = styled.div`
  position: relative;

  max-inline-size: 300px;
  margin-block-end: 40px;
  margin-inline: auto;
  padding-block-start: 96px;

  color: #389810;
  font-size: 40px;
  font-family: ${fontAngkor};
  line-height: 48px;
  text-align: center;

  &:before {
    position: absolute;
    inset-block-start: 0;
    content: "";

    inline-size: 158px;
    block-size: 96px;

    background-image: url(${Pangolin});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    ${props => props.theme.breakpoints.up("desktop")} {
      inline-size: 235px;
      block-size: 143px;
    }
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    max-inline-size: none;
    padding-block-start: 143px;

    font-size: 48px;
    line-height: 54px;
  }
`;

export const ArticleMoreStoriesItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  max-inline-size: 1140px;
  margin-inline: auto;

  ${props => props.theme.breakpoints.up("desktop")} {
    flex-direction: row;
    align-items: flex-start;
  }
`;
